exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".hiddenItems-example span {\n    font-weight: bold;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./packages/custom/hidden-items/public/assets/css/hiddenItems.css
// module id = 808
// module chunks = 0